document.addEventListener('DOMContentLoaded', function () {
  const tryInit = () => {
    const popup = document.getElementById('size-guide-popup');
    const open = document.getElementById('open-size-guide');
    const close = document.getElementById('close-size-guide');

    if (!popup || !open || !close) {
      return setTimeout(tryInit, 100); // Essaie encore dans 100ms
    }

    open.addEventListener('click', function (e) {
      e.preventDefault();
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });

    close.addEventListener('click', function () {
      popup.style.display = 'none';
      document.body.style.overflow = 'auto';
    });

    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        popup.style.display = 'none';
        document.body.style.overflow = 'auto';
      }
    });
  };

  tryInit(); // lance l’init
});